import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=18923b09"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"
import style0 from "./UserEdit.vue?vue&type=style&index=0&id=18923b09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports